export const Delegate = {
    path: '/delegates',
    name: 'delegates',
    component: () => import('@/views/Delegate/DelegatePage.vue'),
    children: [
        {
            path: '/delegates/add',
            name: 'delegates.add',
            component: () => import('@/views/Delegate/Form/DelegateForm.vue'),
            props: {addAction: true},
        },
        {
            path: '/delegates/edit/:id',
            name: 'delegates.edit',
            component: () => import('@/views/Delegate/Form/DelegateForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/delegates/delete/:id',
            name: 'delegates.delete',
            component: () => import('@/views/Delegate/Form/DelegateForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/delegates/view/:id',
            name: 'delegates.view',
            component: () => import('@/views/Delegate/Form/DelegateForm.vue'),
            props: {viewAction: true}
        },
    ]
}